var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirtcubeProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5C5454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.9063C5.5 9.98746 9.48746 6 14.4062 6H19.6602V35H14.3615C9.46745 35 5.5 31.0326 5.5 26.1385V14.9063Z",
    fill: "#00ADEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0078,
    height: 5.66406,
    rx: 2.83203,
    transform: "matrix(1 0 0 -1 22.4922 11.6641)",
    fill: "#FFC704"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5938 35H22.4922V14.4961H34.5V21.4345H29.6562C28.8278 21.4345 28.1562 22.1061 28.1562 22.9345V26.5615C28.1562 27.3899 28.8278 28.0615 29.6562 28.0615H34.2819C33.3861 32.0335 29.8364 35 25.5938 35Z",
    fill: "#FF0048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirtcubeProfile);
export default __webpack_public_path__ + "static/media/dirtcube_profile.e64728cd6274136d20b4b80e476acc00.svg";
export { ForwardRef as ReactComponent };